import { formatDate, IconAttention } from '@ui/src';
import { CardsTransactions } from '../../types';

import cn from '../styles.module.css';

const formatCardTransacationList = (
  list: CardsTransactions[],
): CardsTransactions[] => {
  const nextList = list.map((item) => {
    const result = { ...item };

    result.date = formatDate(result.date, true);

    if (result.transaction === 'good') {
      result.render = {
        description: (
          <div className={cn.goodTransaction}>{result.description}</div>
        ),
        amount: <div className={cn.goodTransaction}>{result.amount}</div>,
      };
    }

    if (result.transaction === 'warning') {
      result.render = {
        amount: (
          <div>
            <span className={cn.attentionIconWrapper}>
              <IconAttention />
            </span>
            {result.amount}
          </div>
        ),
      };
    }

    if (result.transaction === 'canceled') {
      result.render = {
        date: <div className={cn.canceledTransaction}>{result.date}</div>,
        description: (
          <div className={cn.canceledTransaction}>{result.description}</div>
        ),
        currency: (
          <div className={cn.canceledTransaction}>{result.currency}</div>
        ),
        amount: <div className={cn.canceledTransaction}>{result.amount}</div>,
        merchantName: (
          <div className={cn.canceledTransaction}>{result.merchantName}</div>
        ),
        orderDetails: (
          <div className={cn.canceledTransaction}>{result.orderDetails}</div>
        ),
      };
    }

    return result;
  });

  return nextList;
};

export default formatCardTransacationList;
